var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.sendToGame}},[_vm._v("Send to game")]),_c('div',{attrs:{"id":"furioosContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }